import axios from '@/lib/axios'
import { useQuery } from '@tanstack/vue-query'
import { type MaybeRef, get } from '@vueuse/core'
import { computed } from 'vue'

import type { CustomAxiosRequestConfig } from '@/interfaces/customAxiosRequestConfig'

import type { HotelSearchSettings } from '../interfaces/hotelSearchSettings'

export default function useHotelSearchSettings(
	memberId: MaybeRef<number | undefined>,
	isInternal: MaybeRef<boolean>,
	users: MaybeRef<number[]>
) {
	const { data, isFetching, isError, refetch } = useQuery(
		[
			'hotelSearchSettings',
			computed(() => get(memberId)),
			computed(() => get(users)),
		],
		async () =>
			(
				await axios.get<{ data: HotelSearchSettings }>(
					'/api/hotels/search-settings',
					{
						params: { memberId: get(memberId), users: get(users) },
						errorHandling: false,
					} as CustomAxiosRequestConfig
				)
			).data.data,
		{
			enabled: computed(() => !get(isInternal) || !!get(memberId)),
			retry: false,
			staleTime: 60_000,
			refetchInterval: 60_000,
		}
	)

	return { settings: data, isFetching, isError, refetch }
}
